import { render, staticRenderFns } from "./MarketingStoreBanner.vue?vue&type=template&id=1fb84a08&scoped=true&"
import script from "./MarketingStoreBanner.vue?vue&type=script&lang=js&"
export * from "./MarketingStoreBanner.vue?vue&type=script&lang=js&"
import style0 from "./MarketingStoreBanner.vue?vue&type=style&index=0&id=1fb84a08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb84a08",
  null
  
)

export default component.exports